import React from 'react';
import { EXPORT_WAITING_MESSAGE } from '../../helpers/exportHelpers';

const STATUS_COLOURS = {
	RUNNING: 'bg-primary',
	FINISHED: 'bg-success',
	PARTIAL: 'bg-warning text-dark',
	FAILED: 'bg-danger'
};

export const ExportStatusBadge = ({ state }) => (
	<span className={`badge ${STATUS_COLOURS[state] || 'bg-secondary'}`}>
		{state === 'WAITING' ? EXPORT_WAITING_MESSAGE
			: STATUS_COLOURS[state] ? state : 'No status available'}
	</span>
);

const displayDate = (value) => value && Number.isFinite(Date.parse(value))
	? new Date(value).toLocaleString()
	: '—';

export const ExportTable = ({ rows, waiting }) => (
	<div className="table-responsive mt-3">
		<table className="captureTable">
			<thead>
				<tr>
					<th>Dataset</th>
					<th>Status</th>
					<th>Progress</th>
					<th>Details</th>
				</tr>
			</thead>
			<tbody>
				{rows.map(({ key, label, status }) => {
					const processed = (status?.completed || 0) + (status?.failed || 0);
					const progress = status?.expected > 0
						? Math.min(100, Math.round(processed / status.expected * 100))
						: null;
					return (
						<tr key={key}>
							<td>{label}</td>
							<td>{!status && waiting
								? EXPORT_WAITING_MESSAGE
								: <ExportStatusBadge state={status?.state} />}</td>
							<td>
								{status?.expected != null ? (
									<>
										<div>{processed} / {status.expected} processed</div>
										{progress !== null && (
											<div className="progress mt-2" style={{ minWidth: '140px' }}>
												<div className="progress-bar" role="progressbar"
													aria-label={`${label} progress`} aria-valuenow={progress}
													aria-valuemin={0} aria-valuemax={100} style={{ width: `${progress}%` }}>
													{progress}%
												</div>
											</div>
										)}
									</>
								) : '—'}
							</td>
							<td>
								{status && (
									<>
										{status.completed != null && <div>Successful: {status.completed}</div>}
										{status.failed != null && <div>Failed: {status.failed}</div>}
										{status.message && <div>{status.message}</div>}
										{status.maxDate && <div>Data through: {status.maxDate}</div>}
										{(status.executionStartedAt || status.exportStartedAt) && (
											<div>Started: {displayDate(status.executionStartedAt || status.exportStartedAt)}</div>
										)}
										{(status.finishedAt || status.validatedAt) && (
											<div>Completed: {displayDate(status.finishedAt || status.validatedAt)}</div>
										)}
										{status.failedAt && <div>Failed at: {displayDate(status.failedAt)}</div>}
										{status.failedSiteIds?.length > 0 && (
											<div className="mt-2 text-break">
												<strong>Failed site IDs:</strong> {status.failedSiteIds.join(', ')}
											</div>
										)}
									</>
								)}
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	</div>
);
